<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('report.report_preview') }}</div>
    <div slot="body" class="preview-body">
      <div v-if="htmlContent" class="preview-content-wrapper">
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div v-html="htmlContent" class="preview-content"></div>
      </div>
      <div v-else class="empty-preview">
        <a-empty :description="$t('report.no_preview_content')" />
      </div>
    </div>
    <div slot="footer">
      <a-button @click="cancelDialog">{{ $t('dialog.ok') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ReportPreviewDialog',
  mixins: [DialogMixin, WindowsMixin],
  computed: {
    htmlContent () {
      if (!this.params.data || !this.params.data.content || !this.params.data.content.body) {
        return null
      }
      return this.params.data.content.body
    },
  },
}
</script>

<style lang="less" scoped>
.preview-body {
  background: #fff;
}

.preview-content-wrapper {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  transform: translateZ(0);
}

.preview-content {
  width: 100%;
  padding: 20px;
}

.empty-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
</style>

<style lang="less">
// 确保 HTML 内容中的样式能够正确应用
.preview-content-wrapper ::v-deep {
  * {
    box-sizing: border-box;
  }
}
</style>
